<template>
  <v-container>
    <!-- 使用 v-if 來控制 Dialog 的顯示，關閉時銷毀內容 -->
    <v-dialog v-if="dialogVisible" v-model="dialogVisible" persistent max-width="400px">
      <v-card class="pa-4">
        <div style="height:32px;"></div>
        <p>請輸入統一編號，如不需要可略過</p>
        <v-text-field label="統一編號" v-model="inputBuyerVat" class="subtitle-1" :counter="8" color="primary" flat
          type="number" outlined></v-text-field>
        <!-- <v-radio-group v-model="invoice" row>
          <v-radio label="紙本發票" :value="1"></v-radio>
          <v-radio label="線上載具" :value="2"></v-radio>
          <v-radio label="捐贈碼" :value="3"></v-radio>
        </v-radio-group> -->
        <div style="display:flex;margin:16px 0;">
          <label for="h-one" style="font-size:16px;">
            <input type="radio" id="h-one" :value="1" v-model="invoice"><span style="padding-left:8px;">紙本發票</span>
          </label>
          <span style="width:32px;"></span>
          <label for="h-two" style="font-size:16px;">
            <input type="radio" id="h-two" :value="2" v-model="invoice"><span style="padding-left:8px;">線上載具</span>
          </label>
          <span style="width:32px;"></span>
          <label for="h-three" style="font-size:16px;">
            <input type="radio" id="h-three" :value="3" v-model="invoice"><span style="padding-left:8px;">捐贈碼</span>
          </label>
        </div>
        <div v-show="invoice === 1" style="height:86px;"></div>
        <v-text-field label="載具" v-show="invoice === 2" v-model="invoiceCarrierCode" class="subtitle-1" color="primary"
          flat type="text" outlined></v-text-field>
        <v-text-field label="捐贈碼" v-show="invoice === 3" v-model="invoiceDonateCode" class="subtitle-1" color="primary"
          flat type="text" outlined></v-text-field>
        <v-card-actions class="justify-end">
          <v-btn @click="closeDialog('cancel')" color="red">略過</v-btn>
          <v-btn @click="closeDialog('confirm')" color="green" :disabled="isLockSubmit">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const PosTransaction = require('../modules/pos_transaction');

export default {
  data() {
    return {
      dialogVisible: false,
      inputBuyerVat: '', // 統一編號
      invoice: 1, // 發票或載具或捐贈碼
      invoiceCarrierCode: '', // 載具
      invoiceDonateCode: '', // 捐贈碼
    };
  },
  mounted() {
  },
  methods: {
    openDialog() {
      this.inputBuyerVat = '';
      this.invoice = 1;
      this.invoiceCarrierCode = '';
      this.invoiceDonateCode = '';
      this.dialogVisible = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    async closeDialog(action) {
      if (action === 'confirm') {
        await this.setInvoice();
      }
      // 傳回結果給 Promise
      if (this.resolve) {
        await this.resolve();
      }
      this.dialogVisible = false;
      // 清空 resolve，確保每次調用都重新設置
      this.resolve = null;
    },
    // 檢查統編
    checkBuyerVat(code) {
      const regexp = /^[0-9]{8}$/;
      return regexp.test(code);
    },
    // 檢查載具
    checkCarrierCode(code) {
      // 定義三種電子載具格式的正則表達式
      const mobileBarcodeRegex = /^[A-Z0-9.+-]{8}$/; // 手機條碼（8 碼英數字，可含 `+ . -`）
      const citizenCardRegex = /^[A-Z]{2}[0-9]{14}$/; // 自然人憑證（2 個大寫字母 + 14 碼數字）
      const companyCarrierRegex = /^\/[0-9A-Z]{7}$/; // 公司行號載具（"/" 開頭 + 7 碼英數字）
      // 只要符合任一格式，即回傳 true，否則回傳 false
      return (mobileBarcodeRegex.test(code) || citizenCardRegex.test(code) || companyCarrierRegex.test(code));
    },
    // 檢查捐贈碼
    checkDonateCode(code) {
      return /^[0-9]{3,7}$/.test(code);
    },
    async setInvoice() {
      try {
        // 設定統編
        if (this.inputBuyerVat.length > 0) this.$store.dispatch('setOrderContent', { invoiceBuyerVat: this.inputBuyerVat });
        if (this.invoice !== 1) {
          let type = '';
          let code = '';
          let text = '';
          // 設定載具
          if (this.invoice === 2) {
            this.$store.dispatch('setOrderContent', { invoiceCarrierCode: this.invoiceCarrierCode });
            type = 'invoiceCarrierCode';
            code = this.invoiceCarrierCode;
            text = '載具';
          }
          // 設定捐贈碼
          if (this.invoice === 3) {
            this.$store.dispatch('setOrderContent', { invoiceDonateCode: this.invoiceDonateCode });
            type = 'invoiceDonateCode';
            code = this.invoiceDonateCode;
            text = '捐贈碼';
          }
          const { token } = this.$store.getters;
          if (!token) return;
          const res = await PosTransaction.codeVerification(token, { type, code });
          if (res?.isExist === 'N') {
            console.log(`${text}錯誤`);
            return;
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
  },
  computed: {
    isLockSubmit() {
      return (this.inputBuyerVat.length > 0 && this.checkBuyerVat(this.inputBuyerVat) === false)
        || (this.invoice === 2 && this.checkCarrierCode(this.invoiceCarrierCode) === false)
        || (this.invoice === 3 && this.checkDonateCode(this.invoiceDonateCode) === false);
    },
  },
};
</script>
